module.exports = __webpack_public_path__ + "static/media/0_2019_06_27.9b778900.jpg";